import * as Sentry from "@sentry/react";
import React from "react";

import ComponentLoader from "../../../../components/Spinner/ComponentLoader";
import SurveyDetails from "./SurveyDetails";

import { useRbacPrimaryRolePermissions } from "../../../../api/hooks";
import { getFeatureFlagQuery, useFeatureFlagQuery } from "../../../../hooks/useFeatureFlag";

import { currentUserQuery, rbacPermissionsQuery } from "../../../../api/queries";
import { SimplifiedQuery, dataLoader } from "../../../../api/queries/dataLoader";

import ErrorPage from "../../../Error";

// Data loader function
export const surveyDetailsLoader = () => {
	const queries: (() => SimplifiedQuery)[] = [getFeatureFlagQuery, () => rbacPermissionsQuery("survey")];

	return dataLoader([[currentUserQuery], queries]);
};

const SurveyDetailsPage: React.FC = () => {
	const {
		value: ffSurveys,
		query: { isLoading: isLoadingFFSurveys },
	} = useFeatureFlagQuery("ff-is-surveys-enabled", false);

	const { data: rbacPermissions, isLoading: isLoadingRbacPermissions } = useRbacPrimaryRolePermissions("surveys");

	if (!ffSurveys && !isLoadingFFSurveys) {
		return <ErrorPage code={403} />;
	}

	if (
		(!rbacPermissions?.includes("surveys:updateSurvey") ||
			!rbacPermissions?.includes("surveys:viewSurveyResponses")) &&
		!isLoadingRbacPermissions
	) {
		return <ErrorPage code={403} />;
	}

	if (isLoadingFFSurveys || isLoadingRbacPermissions) {
		return <ComponentLoader />;
	}

	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<SurveyDetails />
		</Sentry.ErrorBoundary>
	);
};

export default SurveyDetailsPage;
